import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { usePaymentContext } from 'features/payment';
import { useIntl } from 'react-intl';
import { GestureResponderEvent } from 'react-native';

import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import {
  PaymentNotAvailableContainer,
  PaymentNotAvailableLink,
  PaymentNotAvailableMessage,
  PaymentNotAvailableText,
} from './styled';

interface IPaymentNotAvailableProps {
  collapsed?: boolean;
  onPress?: (e: GestureResponderEvent) => void;
  isExpired?: boolean;
  isQuickPay?: boolean;
}

export const PaymentNotAvailable: React.FC<IPaymentNotAvailableProps> = ({
  collapsed,
  onPress,
  isExpired = false,
  isQuickPay = false,
}) => {
  const { formatMessage } = useIntl();
  const message = isExpired
    ? formatMessage({ id: 'expiredCard' })
    : formatMessage({ id: 'unverifiedCard' });
  const { setIsQuickPayMethodSelected } = usePaymentContext();

  return (
    <PaymentNotAvailableContainer
      isCollapsed={collapsed}
      testID="payment-not-available-badge"
      onPress={onPress}
    >
      <Icon
        variant="warning"
        color={Styles.color.error}
        size={5}
        {...hiddenAccessibilityPlatformProps}
      />
      <PaymentNotAvailableText>
        <PaymentNotAvailableMessage>{message}</PaymentNotAvailableMessage>
        <PaymentNotAvailableLink
          onPointerDown={() =>
            isQuickPay ? setIsQuickPayMethodSelected(true) : setIsQuickPayMethodSelected(false)
          }
        >
          {formatMessage({ id: 'update' })}
        </PaymentNotAvailableLink>
      </PaymentNotAvailableText>
    </PaymentNotAvailableContainer>
  );
};
